import styled from "styled-components";
import { Dialog } from "@material-ui/core";

const DialogStyles = styled(Dialog).attrs({
  classes: { paper: "DialogStyles" }
})`
  .DialogStyles {
    width: 50vw;
    max-width: 100%;
    margin: 0 0 0 auto;
    height: 100vh;
    max-height: 100vh;

    @media (max-width: 600px) {
      width: 100%;
    }
  }
`;

export default DialogStyles;
